module.exports = __webpack_public_path__ + "img/par_32.37382181.jpg";